import React, { useState } from 'react';
import AnimatedCredits from '../ui/AnimatedCredits';
import MediumButton from '../ui/MediumButton';
import typography from '../../utils/typography';
import colors from '../../utils/colors';

import {
  HomeIcon,
  CreateIcon,
  StudioIcon,
  LibraryIcon,
  ExploreIcon,
  SearchIcon,
  NotificationsIcon,
  ChevronLeftIcon,
  ChevronDownIcon,
  GiftIcon,
  NewsIcon,
  MoreVerticalIcon,
  TwitterXIcon,
  InstagramIcon,
  TiktokIcon,
  DiscordIcon,
  PlayIcon
} from '../../utils/icons';

// Icons
const SunoLogo = () => (
  <svg
    width={98}
    height={24}
    viewBox="0 0 98 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-[97.41px] h-6 relative"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.49655 22.9846C6.23085 23.5749 8.05991 23.8701 9.98659 23.8701V23.8643C13.1422 23.8643 15.6087 23.2253 17.3918 21.9472C19.1721 20.6691 20.0651 18.8781 20.0651 16.5741C20.0651 14.657 19.5109 13.2041 18.3997 12.2183C17.2885 11.2296 15.3819 10.5046 12.6742 10.0404C9.75401 9.53602 7.84169 9.08611 6.93721 8.69638C6.03273 8.30665 5.57905 7.66475 5.57905 6.77066C5.57905 5.81639 5.94946 5.11144 6.69027 4.6558C7.43108 4.20016 8.4418 3.97091 9.72817 3.97091C11.1093 3.97091 12.4387 4.20303 13.7136 4.66153C14.9885 5.1229 16.2117 5.79347 17.3803 6.67323L18.8993 3.47801C17.946 2.42918 16.6453 1.61247 15 1.02214C13.349 0.428952 11.6233 0.133789 9.81144 0.133789C6.81374 0.133789 4.53675 0.818682 2.9776 2.17987C1.42132 3.54393 0.640313 5.26332 0.640313 7.33519C0.640313 9.25519 1.20597 10.6909 2.33442 11.6509C3.46286 12.6109 5.40103 13.3015 8.14605 13.7285C11.0059 14.2128 12.8809 14.6541 13.7653 15.0524C14.6526 15.4479 15.0947 16.0955 15.0947 16.9839C15.0947 17.9725 14.7129 18.7262 13.9548 19.2506C13.1968 19.7722 12.0856 20.0329 10.6269 20.0329C8.79785 20.0329 7.16692 19.775 5.73698 19.2506C4.30704 18.7291 2.96899 17.9439 1.72282 16.8979L0 20.2393C1.2634 21.4801 2.76225 22.3942 4.49655 22.9846Z"
      fill="#FAF7F5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.4881 21.8573C28.0237 23.2844 31.3199 23.9979 34.8009 23.9979H34.8067C38.2876 23.9979 41.581 23.2844 43.1194 21.8573C44.6549 20.4302 45.567 18.2151 45.4227 15.2262C45.3506 13.7274 44.8339 10.75 44.8454 9.24843C44.857 7.97035 45.3506 5.44284 45.4227 4.16476C45.4747 3.22196 45.4227 0.393555 45.4227 0.393555H40.4351C40.4351 0.393555 40.1984 3.25348 40.4351 4.16476C40.8074 5.60331 43.307 7.88724 43.3214 9.37452C43.3359 10.8618 40.8074 13.3234 40.4351 14.8164C39.9848 16.6275 40.1031 18.003 39.4364 18.7796C38.7696 19.5562 36.703 19.9459 34.8038 19.9459C32.9045 19.9459 30.8379 19.5591 30.1711 18.7796C29.5044 18.003 29.1725 16.6791 29.1725 14.8164V0.393555H24.1848V15.2262C24.1848 18.2208 24.9526 20.4273 26.4881 21.8573Z"
      fill="#FAF7F5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.5248 23.6023C64.5248 23.6023 62.644 20.5816 62.2449 19.4696C61.5758 17.601 61.84 13.3507 60.7948 11.6626C59.9879 10.3586 56.9011 9.12336 55.8961 7.9655C55.4395 7.43816 54.5522 5.52941 54.5522 5.52941V23.6023H50.2307V0.393555H57.0935C57.0935 0.393555 59.1982 3.95025 59.7438 5.21129C60.3612 6.64428 60.9154 9.77967 61.6562 11.1525C62.466 12.6514 64.9813 15.0416 65.9289 16.4574C66.2563 16.9475 67.066 18.5209 67.066 18.5209V0.393555H71.3588V23.6023H64.5248Z"
      fill="#FAF7F5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.9335 2.16645C93.2858 0.722149 90.0624 0 86.8419 0C83.0481 0 78.2577 0.398328 76.8433 4.77707C75.5729 8.70878 78.7358 9.56848 78.8079 12.5545C78.8943 16.1767 75.1927 18.3661 78.321 21.8937C80.1704 23.9771 83.5868 24 86.8073 24C90.0307 24 93.2541 23.2864 94.9162 21.8622C96.5726 20.438 97.4051 18.4177 97.4051 15.8042V8.31045C97.4051 5.6597 96.5783 3.61075 94.9278 2.16358L94.9335 2.16645ZM92.3583 15.4402C92.3583 17.2026 91.9867 18.4406 91.2463 19.1627C90.5031 19.8849 88.4493 20.246 86.6662 20.246C84.8831 20.246 82.8292 19.8849 82.086 19.1627C81.3428 18.4406 80.9741 17.1998 80.9741 15.4402V8.67725C80.9741 6.87761 81.3457 5.60525 82.086 4.86304C82.8292 4.12084 84.8831 3.75116 86.6662 3.75116C88.4493 3.75116 90.5031 4.11797 91.2463 4.86304C91.9895 5.60812 92.3583 6.87761 92.3583 8.67725V15.4402Z"
      fill="#FAF7F5"
    />
  </svg>
);

const UserDropdownIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
  >
    <path
      d="M7.99993 8.40264L10.5999 5.80264C10.8577 5.54491 11.2755 5.54491 11.5333 5.80264V5.80264C11.791 6.06037 11.791 6.47824 11.5333 6.73597L8.47133 9.7979C8.21098 10.0583 7.78887 10.0583 7.52852 9.7979L4.4666 6.73597C4.20886 6.47824 4.20886 6.06037 4.4666 5.80264V5.30264C4.72433 5.54491 5.1422 5.54491 5.39993 5.80264L7.99993 8.40264Z"
      fill="#BAB4B1"
    />
  </svg>
);



const PlayerIcon = ({ isActive }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
  >
    <path
      d="M8 5V19L19 12L8 5Z"
      fill={isActive ? "#FAF7F5" : "#FAF7F5"}
    />
  </svg>
);


// Navigation Items
const navigationItems = [
  { icon: HomeIcon, label: "Home", key: "home" },
  { icon: CreateIcon, label: "Create", key: "create" },
  { icon: StudioIcon, label: "Studio", key: "studio" },
  { icon: LibraryIcon, label: "Library", key: "library" },
  { icon: SearchIcon, label: "Search", key: "search" },
  { icon: PlayIcon, label: "Hooks", key: "hooks" },
  { icon: ExploreIcon, label: "Explore", key: "explore" },
  { icon: NotificationsIcon, label: "Notifications", key: "notifications" },
  { icon: PlayerIcon, label: "Player", key: "player" }
];

const Navigation = ({ activeItem = "create", onNavigate, credits, sidePanelOpen = false, onOpenMobilePlayer, onCollapseRequest, onCollapseChange, onToggleBanners }) => {
  const [user] = useState({ name: "Daniel", username: "@danielmusic", avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=80&h=80&fit=crop&crop=face" });
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [manuallyToggled, setManuallyToggled] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [isUserProfileHovered, setIsUserProfileHovered] = useState(false);

  const handleItemClick = (key) => {
    if (key === 'player') {
      // Open mobile player with a demo song
      const demoSong = {
        id: 'demo-1',
        title: 'Demo Song',
        artist: 'Demo Artist',
        duration: '3:15',
        image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=67&h=67&fit=crop&crop=center'
      };
      onOpenMobilePlayer?.(demoSong);
    } else {
      onNavigate?.(key);
    }
  };

  const toggleCollapse = () => {
    const newCollapsed = !isCollapsed;
    setIsCollapsed(newCollapsed);
    setManuallyToggled(true); // Mark as manually toggled
    onCollapseChange?.(newCollapsed);
  };

  const collapseNavigation = () => {
    setIsCollapsed(true);
    onCollapseChange?.(true);
  };

  // Expose collapse function to parent
  React.useEffect(() => {
    if (onCollapseRequest) {
      onCollapseRequest(collapseNavigation);
    }
  }, [onCollapseRequest]);

  const handleMouseEnter = (itemKey, event) => {
    if (shouldBeCollapsed) {
      const rect = event.currentTarget.getBoundingClientRect();
      setTooltipPosition({
        x: rect.right + 12, // 12px to the right of the nav item
        y: rect.top + (rect.height / 2) - 16 // Center vertically with the icon
      });
      setHoveredItem(itemKey);
    }
  };

  const handleMouseLeave = () => {
    if (shouldBeCollapsed) {
      setHoveredItem(null);
    }
  };

  // Clear tooltip on any click to prevent it from getting stuck
  React.useEffect(() => {
    const handleClick = () => {
      setHoveredItem(null);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  // Auto-collapse when side panel opens, but respect manual toggles
  React.useEffect(() => {
    if (sidePanelOpen) {
      setIsCollapsed(true);
      onCollapseChange?.(true);
    } else if (sidePanelOpen === false && !manuallyToggled) {
      // Only auto-expand if side panel explicitly closes AND user hasn't manually toggled
      setIsCollapsed(false);
      onCollapseChange?.(false);
    }
  }, [sidePanelOpen]);

  const shouldBeCollapsed = isCollapsed;

  return (
    <div 
      className={`flex flex-col justify-between items-start h-screen bg-transparent border-r border-white/10 relative z-50 ${
        shouldBeCollapsed ? 'overflow-visible' : 'w-[220px] overflow-hidden'
      }`}
      style={{ 
        minWidth: shouldBeCollapsed ? '76px' : '220px', 
        maxWidth: shouldBeCollapsed ? '76px' : '220px',
        width: shouldBeCollapsed ? '76px' : '220px',
        backgroundColor: colors.bg.primary // Add background to ensure it's visible over HooksEditor
      }}
    >
      {/* Top Section */}
      <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0">
        {/* Logo */}
        <div className="flex justify-between items-center self-stretch flex-grow-0 flex-shrink-0 relative p-6">
          <div className={`flex items-center ${shouldBeCollapsed ? 'opacity-0 w-0 overflow-hidden' : 'opacity-100'}`}>
            <SunoLogo />
          </div>
          <button
            onClick={toggleCollapse}
            className="flex items-center justify-center w-5 h-5 hover:opacity-70 flex-shrink-0"
            style={{
              marginLeft: shouldBeCollapsed ? '-42px' : '0',
              color: colors.text.inactive
            }}
          >
            <ChevronLeftIcon />
          </button>
        </div>

        {/* User Profile */}
        <div 
          className="flex justify-between items-center self-stretch flex-grow-0 flex-shrink-0 relative p-6"
          onMouseEnter={() => setIsUserProfileHovered(true)}
          onMouseLeave={() => setIsUserProfileHovered(false)}
        >
          <div className="flex items-center flex-grow-0 flex-shrink-0 relative">
            {/* Avatar - positioned to align with nav icons when collapsed */}
            <div className={`${
              shouldBeCollapsed ? 'ml-[-4px]' : 'ml-0'
            }`}>
              <img className="w-8 h-8 rounded-full flex-shrink-0" src={user.avatar} alt="User avatar" />
            </div>
            <div className={`flex flex-col justify-start items-start ml-3 ${
              shouldBeCollapsed ? 'opacity-0 w-0 overflow-hidden' : 'opacity-100 w-[84px]'
            }`}>
              <p className="text-left text-[#faf7f5] whitespace-nowrap" style={typography.small.title}>
                {user.name}
              </p>
              <p className="text-left text-[#d1cbc7] whitespace-nowrap" style={typography.small.regular}>
                {user.username}
              </p>
            </div>
          </div>
          <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-200 ${
            shouldBeCollapsed ? 'opacity-0' : (isUserProfileHovered ? 'opacity-100' : 'opacity-0')
          } ${isUserProfileHovered ? 'bg-white/[0.04]' : 'bg-transparent'}`}>
            <div className="w-4 h-4 flex items-center justify-center">
              <ChevronDownIcon style={{ width: '16px', height: '16px' }} />
            </div>
          </div>
        </div>

        {/* Navigation Items */}
        <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-3 px-6 pt-2 pb-6">
          {navigationItems.filter(item => item.key !== 'player').map((item) => {
            const isActive = activeItem === item.key;
            const IconComponent = item.icon;
            
            return (
              <div
                key={item.key}
                className={`flex items-center self-stretch flex-grow-0 flex-shrink-0 relative cursor-pointer hover:opacity-80 transition-opacity ${
                  isActive ? 'opacity-100' : 'opacity-40'
                }`}
                onClick={() => handleItemClick(item.key)}
                onMouseEnter={(e) => handleMouseEnter(item.key, e)}
                onMouseLeave={handleMouseLeave}
              >
                {/* Icon container - fixed position */}
                <div className="flex-shrink-0 w-4 h-4 flex items-center justify-center">
                  <IconComponent isActive={isActive} />
                </div>

                {/* Label - smooth transition */}
                <div className={`ml-2 ${
                  shouldBeCollapsed ? 'opacity-0 w-0 overflow-hidden' : 'opacity-100'
                }`}>
                  <p className={`text-left whitespace-nowrap text-sm font-medium ${
                    isActive ? 'text-white' : 'text-[#faf7f5]'
                  }`}>
                    {item.label}
                  </p>
                </div>

              </div>
            );
          })}
        </div>
      </div>

      {/* Bottom Section */}
      {!shouldBeCollapsed && (
        <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 bg-transparent">
        {/* Credits and Pro Upgrade */}
        <div className="flex flex-col justify-center items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-4 px-6 pt-6">
          {/* Credits display */}
          <p className="self-stretch flex-grow-0 flex-shrink-0 w-48 text-center" style={typography.xsmall.regular}>
            <AnimatedCredits credits={credits} className="text-white" />
            <span className="text-white/70"> Credits</span>
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              alignSelf: "stretch",
              flexGrow: 0,
              flexShrink: 0,
              gap: 12,
              padding: 12,
              borderRadius: 20,
              background: "rgba(90,90,90,0.2)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                alignSelf: "stretch",
                flexGrow: 0,
                flexShrink: 0,
                position: "relative",
                gap: 4,
              }}
            >
              <p
                style={{
                  alignSelf: "stretch",
                  flexGrow: 0,
                  flexShrink: 0,
                  width: 152,
                  fontSize: 16,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#f7f4ef",
                }}
              >
                Go pro
              </p>
              <p
                style={{
                  alignSelf: "stretch",
                  flexGrow: 0,
                  flexShrink: 0,
                  width: 152,
                  fontSize: 12,
                  textAlign: "left",
                  color: "#a3a3a3",
                }}
              >
                Unlock new features and more!
              </p>
            </div>
            <div className="w-full">
              <div onClick={onToggleBanners}>
                <MediumButton
                  variant="aura"
                  text="Upgrade"
                  className="w-full !w-full"
                  style={{ width: '100%', minWidth: '100%' }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Links */}
        <div className="flex flex-col justify-center items-center self-stretch flex-grow-0 flex-shrink-0 gap-6 p-6">
          <div className="flex flex-col justify-center items-center self-stretch flex-grow-0 flex-shrink-0 gap-6">
            <div className="flex justify-center items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-2 cursor-pointer hover:opacity-80 transition-opacity">
              <div className="w-4 h-4 flex items-center justify-center" style={{ color: colors.text.tertiary }}>
                <MoreVerticalIcon style={{ width: '16px', height: '16px' }} />
              </div>
              <p className="flex-grow-0 flex-shrink-0 text-left text-sm font-medium" style={{ color: colors.text.tertiary }}>
                More from Suno
              </p>
            </div>
          </div>
        </div>

        {/* Social Media Links */}
        <div className="flex justify-center items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-4 p-6 border-t border-r-0 border-b-0 border-l-0 border-white/10">
          <div className="w-6 h-6 flex items-center justify-center cursor-pointer transition-colors" style={{ color: colors.text.tertiary }} onMouseEnter={(e) => e.currentTarget.style.color = '#ffffff'} onMouseLeave={(e) => e.currentTarget.style.color = colors.text.tertiary}>
            <TwitterXIcon style={{ width: '24px', height: '24px' }} />
          </div>
          <div className="w-6 h-6 flex items-center justify-center cursor-pointer transition-colors" style={{ color: colors.text.tertiary }} onMouseEnter={(e) => e.currentTarget.style.color = '#ffffff'} onMouseLeave={(e) => e.currentTarget.style.color = colors.text.tertiary}>
            <InstagramIcon style={{ width: '24px', height: '24px' }} />
          </div>
          <div className="w-6 h-6 flex items-center justify-center cursor-pointer transition-colors" style={{ color: colors.text.tertiary }} onMouseEnter={(e) => e.currentTarget.style.color = '#ffffff'} onMouseLeave={(e) => e.currentTarget.style.color = colors.text.tertiary}>
            <TiktokIcon style={{ width: '24px', height: '24px' }} />
          </div>
          <div className="w-6 h-6 flex items-center justify-center cursor-pointer transition-colors" style={{ color: colors.text.tertiary }} onMouseEnter={(e) => e.currentTarget.style.color = '#ffffff'} onMouseLeave={(e) => e.currentTarget.style.color = colors.text.tertiary}>
            <DiscordIcon style={{ width: '24px', height: '24px' }} />
          </div>
        </div>
      </div>
      )}
      
      {/* Global tooltip - rendered above everything */}
      {shouldBeCollapsed && hoveredItem && (
        <div 
          className="fixed px-2 py-1 rounded-md whitespace-nowrap border border-white/10 pointer-events-none"
          style={{
            backgroundColor: colors.bg.tertiary,
            color: colors.text.primary,
            ...typography.small.title,
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.3)',
            zIndex: 99999,
            left: `${tooltipPosition.x}px`,
            top: `${tooltipPosition.y}px`
          }}
        >
          {navigationItems.find(item => item.key === hoveredItem)?.label}
        </div>
      )}
    </div>
  );
};

export default Navigation;